import { ChangeEvent, MouseEvent, useEffect, useState } from "react";
import { findSubSegmentProps, jdlProps } from "../../../../../utils/types";
import { getClients, getDomains, getSegments,  getSubSegments, getJdlStatus } from "../../../../../services/apis/jdl-apis/jdl.client";
import { findClientProps, findDomainProps, findSegmentProps, statusProps } from "../../../../../utils/types";
import { api, getToken } from "../../../../../services/apis/auth-api/apiUrl";
import { SAVE_JDL_END_POINT } from "../../../../../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { AxiosError } from "axios";

export default function AddJob (){
    const jdlDefaultData = {
        position_title : '',
        client : {client_id : 0, client_name : ''},
        domain :{ domain_id : 0, domain_name : ''},
        segment : {segment_id : 0, segment_name : ''},
        sub_segment : 0,
        career_level : 'CL1',
        fte : 1,
        budget : 'To Follow',
        shift_schedule: '', 
        location: '', 
        job_description : 'To Follow',
        status : 0
    }
    const defaultStatus = {
        client: { valid : false, msg : ''},
        position : { valid : false, msg : ''},
        domain : { valid : false, msg : ''},
        segment : { valid : false, msg : ''},
        submit_status : { valid : false, msg : '' }
     }
    const [jdlData, setJdlData] = useState<jdlProps>(jdlDefaultData);
    const [suggestedClients, setSuggestedClients] = useState<findClientProps[]>([]);
    const [suggestedDomains, setSuggestedDomains] = useState<findDomainProps[]>([]);
    const [suggestedSegments, setSuggestedSegments] = useState<findSegmentProps[]>([]);
    const [suggestedSubSegments, setSuggestedSubSegments] = useState<findSubSegmentProps[]>([]);
    const [status, setStatus] = useState(defaultStatus);
    const [loading, setLoading] = useState<boolean>(true);
    const [jdlStatus, setJdlStatus] = useState<statusProps[]>([]);

    useEffect(()=>{
        async function jdlStatus() {
            try{
                const jdlStat = await getJdlStatus();
                setJdlStatus(jdlStat);
                setLoading(false);
            }catch(e){}
        }
        jdlStatus();
    },[])

    function updateJdlData (e : ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) {
        const {name, value} = e.target;

        setJdlData({
            ...jdlData,
            [name] : value
        })
    }

    async function updateJdlClientsInfo (e : ChangeEvent<HTMLInputElement>) {
        const {name, value} = e.target;

        switch (name) {
            case 'client':
                setJdlData({
                    ...jdlData,
                    [name] : {client_id : 0, client_name : value}
                })
                if (value.length === 0) {
                    setSuggestedClients([]);
                    setStatus({
                        ...status,
                        client : {valid : false, msg : 'Required'}
                    })

                    return false;
                }

                try{

                    const client = await getClients(value);
                    if(client.length > 0) return setSuggestedClients(client);

                    setSuggestedClients([]);
                    setStatus({
                        ...status,
                        client : {valid : false, msg : 'Client not exist'}
                    })
                    setJdlData({
                        ...jdlData,
                        [name] : {client_id : 0, client_name : value}
                    })
                }catch(e){}
                break;
            case 'domain':
                setJdlData({
                    ...jdlData,
                    [name] : {domain_id : 0, domain_name : value},
                    segment : {segment_id : 0, segment_name : ''}
                })

                if(value === '') {
                    setSuggestedDomains([]);
                    setSuggestedSegments([]);
                    setSuggestedSubSegments([]);
                    setStatus({
                        ...status,
                        domain : {valid : false, msg : 'Required.'},
                        segment : {valid : false, msg : 'Select domain first.'}
                    })
                    return false;
                }

                try{
                    const domain = await getDomains(value);
                    if(domain.length > 0) return setSuggestedDomains(domain);

                    setSuggestedDomains([]);
                    setStatus({
                        ...status,
                        domain : {valid : false, msg : 'Domain not exist'}
                    })
                    setJdlData({
                        ...jdlData,
                        [name] : {domain_id : 0, domain_name : value}
                    })
                }catch(e){}
                break;
            case 'segment':
                setJdlData({
                    ...jdlData,
                    [name] : {segment_id : 0, segment_name : value}
                })

                if(jdlData.domain.domain_id === 0) return setStatus({
                    ...status, 
                    segment : {valid : false, msg : 'Select domain first.'}
                })

                if(value === '') { 
                    setStatus({
                        ...status, 
                        segment : {valid : false, msg : 'Required'}
                    })
                    setSuggestedSubSegments([]);
                    return false;
                }

                try {
                    const segment = await getSegments(value, jdlData.domain.domain_id);
                    if(segment.length > 0) return setSuggestedSegments(segment);

                    setSuggestedSegments([]);
                    setStatus({
                        ...status,
                        segment : {valid : false, msg : 'Segment not exist'}
                    })
                    setJdlData({
                        ...jdlData,
                        [name] : {segment_id : 0, segment_name : value}
                    })
                }catch(e){}
                break;
        }
    }

    function updateClient (id : number, name : string){
        setJdlData({
            ...jdlData,
            client : {client_id: id, client_name : name}
        })
        setStatus({
            ...status,
            client : {valid : true, msg : 'Valid'}
        })
        setSuggestedClients([]);
    }

    function updateDomain (id : number, name : string){
        setJdlData({
            ...jdlData,
            domain : {domain_id: id, domain_name : name},
            segment : {segment_id : 0, segment_name : ''}
        })
        setStatus({
            ...status,
            domain : {valid : true, msg : 'Valid'},
            segment : {valid : false, msg : ''}
        })
        setSuggestedDomains([]);
        setSuggestedSegments([]);
    }

    async function updateSegment(id : number, name : string) {
        setJdlData({
            ...jdlData,
            segment : {segment_id : id, segment_name : name}
        })
        setStatus({
            ...status,
            segment : {valid : true, msg : 'Valid'}
        })
        setSuggestedSegments([]);

        try{
           const subSegments = await getSubSegments(id);
           setSuggestedSubSegments(subSegments);
           console.log(subSegments)
        }catch(e){}
    }

    async function updateSelectInputs(e : ChangeEvent<HTMLSelectElement>) {
        const {name, value} = e.target;
        setJdlData({
            ...jdlData,
            [name] : value 
        })
    }

    function submitJdl ( publish : string, e : MouseEvent<HTMLButtonElement>){
        e.preventDefault();
        setLoading(true);
        const requirements = {
            position_title : jdlData.position_title,
            client_id : jdlData.client.client_id,
            domain_id : jdlData.domain.domain_id,
            segment_id : jdlData.segment.segment_id,
            sub_segment_id : jdlData.sub_segment,
            career_level : jdlData.career_level,
            fte : jdlData.fte,
            budget : jdlData.budget,
            job_description : jdlData.job_description,
            status : jdlData.status,
            publish : publish
        }

        const dataIsNotComplete = Object.values(requirements).some(value => value === '');
        const dataIsZero = Object.values(requirements).some(value => value === 0);
        if(dataIsNotComplete || dataIsZero){
            setLoading(false);
            setStatus({...status, submit_status : {valid : false, msg : 'Please complete all fields.'}});
            return false;
        }

        setTimeout(async()=>{
            try{
                await api.post(SAVE_JDL_END_POINT, requirements, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setStatus({
                    ...status,
                    submit_status : {valid : true, msg : 'JDL Posted!'}
                })
                setJdlData(jdlDefaultData);
            }catch(e){
                const error = (e as AxiosError);
                switch (error.response?.status) {
                    case 401:
                        setStatus({
                            ...status,
                            submit_status : {valid : false, msg : 'Unauthorized access!'}
                        })
                        break;
                    case 409:
                        setStatus({
                            ...status,
                            submit_status : {valid : false, msg : 'JDL Already exist!'}
                        })
                        break;
                    default:
                        setStatus({
                            ...status,
                            submit_status : {valid : false, msg : 'An error occured!'}
                        })
                        break;
                }
            }
            setLoading(false);
        },500);
    }

    return (
        <div className="min-w-96 relative">
            <div className={loading ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div>
                Add New  Job
            </div>
            <div>
                <form>
                    <p className={!status.submit_status.valid ? 'text-red-500' : 'text-green-500'}>
                        {status.submit_status.msg}
                    </p>
                    <div className='flex gap-4'>
                        <div className='flex flex-col min-w-80 max-w-52 min-h-80 pt-4'>
                            <div className='input-container my-0'>
                                <label htmlFor="">Position Title:</label>
                                <input type="text" name="position_title" onChange={updateJdlData} value={jdlData.position_title} className='text-box w-full' />
                            </div>
                            <div className='input-container relative my-0'>
                                <label htmlFor="">Client: <small className={!status.client.valid ? 'text-red-500' : 'text-green-500'}>{status.client.msg}</small></label>
                                <input type="text" name="client" onChange={updateJdlClientsInfo} value={jdlData.client.client_name} className='text-box w-full' />
                                {suggestedClients?.length > 0 ? (
                                <div className="absolute mt-0.5 py-2 overflow-y-auto max-h-36 bg-gray-200 z-10 w-full border shadow-lg rounded">
                                    {suggestedClients.map((value)=>(
                                        <div onClick={()=> updateClient(value.id, value.client_name)} className="cursor-pointer w-full py-1 px-2 hover:bg-blue-500 rounded hover:text-white">
                                            <i>{value.client_name}</i>
                                        </div>
                                    ))}
                                </div>
                                ) : <></>}
                            </div>
                            <div className='input-container relative my-0'>
                                <label htmlFor="">Domain: <small className={!status.domain.valid ? 'text-red-500' : 'text-green-500'}>{status.domain.msg}</small></label>
                                <input type="text" name="domain" onChange={updateJdlClientsInfo} value={jdlData.domain.domain_name} className='text-box w-full' />
                                {suggestedDomains?.length > 0 ? (
                                <div className="absolute mt-0.5 py-2 overflow-y-auto max-h-36 bg-gray-200 z-10 w-full border shadow-lg rounded">
                                    {suggestedDomains.map((value)=>(
                                        <div onClick={()=> updateDomain(value.id, value.domain_name)} className="cursor-pointer w-full py-1 px-2 hover:bg-blue-500 rounded hover:text-white">
                                            <i>{value.domain_name}</i>
                                        </div>
                                    ))}
                                </div>
                                ) : <></>}
                            </div>
                            <div className='input-container relative my-0'>
                                <label htmlFor="">Segment: <small className={!status.segment.valid ? 'text-red-500' : 'text-green-500'}>{status.segment.msg}</small></label>
                                <input type="text" name="segment" onChange={updateJdlClientsInfo} value={jdlData.segment.segment_name} className='text-box w-full' />
                                {suggestedSegments?.length > 0 ? (
                                <div className="absolute mt-0.5 py-2 overflow-y-auto max-h-36 bg-gray-200 z-10 w-full border shadow-lg rounded">
                                    {suggestedSegments.map((value)=>(
                                        <div onClick={()=> updateSegment(value.id, value.segment_name)} className="cursor-pointer w-full py-1 px-2 hover:bg-blue-500 rounded hover:text-white">
                                            <i>{value.segment_name}</i>
                                        </div>
                                    ))}
                                </div>
                                ) : <></>}
                            </div>
                            <div className='input-container my-0'>
                                <label htmlFor="">Sub-Segment:</label>
                                {suggestedSubSegments.length > 0 ?(
                                    <select name="sub_segment" onChange={updateSelectInputs} className='text-box w-full'>
                                         <option value="" className="text-gray-400">Choose Sub Segment</option>
                                        {suggestedSubSegments.map((value)=>(
                                            <option value={value.id}>{value.sub_segment_name}</option>
                                        ))}
                                    </select>
                                ):
                                    <select name="sub_segment" className='text-box w-full'>
                                        <option value="">No sub segment available.</option>
                                    </select> }
                            </div>
                            <div className='flex gap-4 w-full'>
                                <div className='input-container my-0 w-full'>
                                    <label htmlFor="">Career Level:</label>
                                    <input type="text" maxLength={5} name="career_level" onChange={updateJdlData} value={jdlData.career_level} className='text-box w-full' />
                                </div>
                                <div className='input-container my-0 w-full'>
                                    <label htmlFor="">FTE:</label>
                                    <input type="number" name="fte" onChange={updateJdlData} value={jdlData.fte} className='text-box w-full' />
                                </div>
                            </div>
                            <div className='flex gap-4 w-full'>
                                <div className='input-container my-0'>
                                    <label htmlFor="">Budget:</label>
                                    <input type="text" name="budget" onChange={updateJdlData} value={jdlData.budget} className='text-box w-full' />
                                </div>
                                <div className='input-container my-0'>
                                    <label htmlFor="">Status:</label>
                                    <select name="status" onChange={updateSelectInputs} className='text-box w-full'>
                                        <option value="" selected={jdlData.status === 0} className="text-gray-400">Select Status</option>
                                        {jdlStatus.map((value)=>(
                                            <option value={value.id}>{value.status}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="min-w-80 min-h-80 mb-4">
                            <div className="input-container h-full flex flex-col relative">
                                <label htmlFor="#jd">Job Description:</label>
                                <textarea name="job_description" onChange={updateJdlData} value={jdlData.job_description} id="jd" className="text-box p-2 w-full h-full" ></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-4 justify-end my-4 pe-4">
                        <div>
                            <button type="button" onClick={(e)=> submitJdl('No',e)} className="button button-vcc-yellow text-md px-4">
                                Save to upload
                            </button>
                        </div>
                        <div className="hidden">
                            <button type="button" onClick={(e)=> submitJdl('Yes',e)} className='button button-vcc-green text-md px-4'>
                                Publish
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}